import { useMerchant } from '@/src/context/merchant/merchant-context'
import Script from 'next/script'
import React from 'react'

export default function Pixel() {
    const { merchantSummary } = useMerchant()

    if (!merchantSummary?.integrationsConfiguration?.facebookPixelId)
        return <></>

    return (
        <>
            <noscript>
                <img style={{ display: "none", visibility: "hidden", height: "0", width: "0" }}
                    src={`https://www.facebook.com/tr?id=${merchantSummary?.integrationsConfiguration?.facebookPixelId}&ev=PageView&noscript=1`} />
            </noscript>
            <Script
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
                           !function (f, b, e, v, n, t, s) {
                           if (f.fbq) return; n = f.fbq = function () {
                               n.callMethod ?
                               n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                           };
                           if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
                           n.queue = []; t = b.createElement(e); t.async = !0;
                           t.src = v; s = b.getElementsByTagName(e)[0];
                           s.parentNode.insertBefore(t, s)
                       }(window, document, 'script',
                           'https://connect.facebook.net/en_US/fbevents.js');
                       fbq('init', '${merchantSummary?.integrationsConfiguration?.facebookPixelId}');
                       fbq('track', 'PageView');
                   `
                }}
            />
        </>
    )
}
